import { createHideSurpriseFrames } from "../../core/hide-surprise-keyframes.js";

export const meta = Object.freeze({
  id: "hide-surprise",
  label: "Verstecken & Erschrecken",
  duration: 6000,
  description: "Über dem schnell öffnenden Loch abspringen, hineinfallen, hervorschauen und erschrecken.",
  tags: ["body", "expression", "story", "peek", "one-shot", "loopable"],
});

export async function run({ elements, scene, animate }) {
  const frames = createHideSurpriseFrames();
  const options = { duration: meta.duration, easing: "linear" };

  if (!scene?.holeBack || !scene?.holeFront || !scene?.groundCover) {
    throw new Error("Die Versteck-Sequenz benötigt Loch- und Bodenebenen in der Stage.");
  }

  const animations = [
    animate(elements.actor, frames.body, options),
    animate(elements.shadow, frames.shadow, options),
    animate(elements.eyes, frames.eyes, options),
    animate(elements.blink, frames.blink, options),
    animate(elements.openEyes, frames.openEyes, options),
    animate(elements.smileEyes, frames.smileEyes, options),
    animate(elements.glow, frames.glow, options),
    animate(scene.holeBack, frames.holeBack, options),
    animate(scene.holeFront, frames.holeFront, options),
    animate(scene.groundCover, frames.groundCover, options),
  ];

  await Promise.allSettled(animations.map(({ finished }) => finished));
}
